import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem, Link} from '@mui/material';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import axios from 'axios';
import '../../custom'
import { callApi } from '../../common/api';
import { createDeviceToken } from '../../common/FirebaseCall';

function NavigationBar(props){
const [dataProp, setDataProp]=useState([])

const url = process.env.REACT_APP_STRAPI_API
const feUrl = process.env.REACT_APP_CMSFE_URL

React.useEffect(() => {
  getData()
},[]);
async function getData(){
  // setUrl(process.env.REACT_APP_STRAPI_API)
  // setFeUrl(process.env.REACT_APP_CMSFE_URL)

  const HeaderResponse = await axios.get(`${url}/api/headers?populate=*`)
  const Headerdata = HeaderResponse.data.data
  setDataProp(Headerdata)
}
const [isSignedUp, setSignedUp] = useState(false)

    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorSn,setAnchorSn] = React.useState(null)
  const open = Boolean(anchorEl);
  const openSignup = Boolean(anchorSn)
  
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSignupOpen = (event) => {
    setAnchorSn(event.currentTarget);
  };

  const handleSignupClose = () => {
    setAnchorSn(null);
  };
  const routeToHome =()=>{
    window.location.href=(`${feUrl}/`)
  }

  const routeToEvent =()=>{
    window.location.href=(`${feUrl}/events`)
  }

  const handleLinkClick =(link)=>{
    window.location.href=`${link}`
  }
  const handleLogOutClick = async () => {
    // const firebaseToken = await createDeviceToken();
    let token = JSON.parse(localStorage.getItem("accessToken"))
    let obj = {
       accessToken : token
    }
    const response = await callApi("post", "auth/logout", obj)
    localStorage.clear();
    // const firbaseResponse = await callApi('post',`admin/deleteDeviceToken?deviceToken=${firebaseToken}`)
    window.location.href=`${process.env.REACT_APP_LANDING_PAGE_URL}?logout=true`

  }

  React.useEffect(()=>{
    const authenticate =localStorage.getItem("authenticate");
     if(authenticate==='true'){
      setSignedUp(true);
     }else{
      setSignedUp(false)
     }
   },[])

return(
<>    

  <header id="myHeader">
  <div className="sidewarper">
  <div id="slidesection">
    <div className="headerinner">
      <div className="topclose"><a href="#" style={{float: 'left'}}><img src={`${dataProp[0]?.attributes?.HeaderLogo?.data?.attributes?.url}`}  alt=""  width="165"    className="img-fluid"/></a> <a id="slide1" style={{float:'right'}} className="white row2"><CloseIcon sx={{color:'white'}}/></a></div>
      <br></br>
      <div className="overscroll">
        
        <div className="container">
          <div className="footerinformation">
            <ul>
              
             <li ><a href={feUrl}>{dataProp[0]?.attributes?.Icon1}</a></li>
            <li className="accordion">
              <div className="accordion-toggle"><a href="#">{dataProp[0]?.attributes?.Icon2}<span><KeyboardArrowDownIcon sx={{color:'white'}}/></span></a></div>
              <div className="accordion-content">
              <ul className="">
              {dataProp[0]?.attributes?.Icon2Options.map((item, index) => (
                <li><a href={'https://www.fundingpossibilities.com'}>{item.text}</a></li>
              ))}
              </ul>
              
            </div>
            </li>
            <li><a href={`${feUrl}/events`}>{dataProp[0]?.attributes?.Icon3}</a></li>
             {/* <li className="accordion">
              <div className="accordion-toggle"><a href="#">{dataProp[0]?.attributes?.Icon4}<span><KeyboardArrowDownIcon sx={{color:'white'}}/></span></a></div>
              <div className="accordion-content">
              <ul className="">
            {dataProp[0]?.attributes?.Icon4Options.map((item, index) => (
                <li><a href={`${item.link}`}>{item.text}</a></li>
            ))}
              </ul>
            </div>
            </li> */}
            </ul>
          </div>
          <li style={{ marginTop: 'auto', textAlign: 'right' }}>
            {isSignedUp ? 
              <a href={`${feUrl}/?type=investor`} onClick={handleLogOutClick}>Log Out</a> 
              : 
              <a href={`${feUrl}/?type=investor`}>{dataProp[0]?.attributes?.ButtonText}</a>
            }
          </li>
 


        </div>
      </div>
    </div>
  </div>
</div>
  <div className="container py-3">
    <div className="d-flex justify-content-between m-0 align-items-center">
      <div className="logo"> <a href="#"><img src={`${dataProp[0]?.attributes?.HeaderLogo?.data?.attributes?.url}`}  alt=""  width="165"    className="img-fluid"/></a> </div>
      <div className="mainlinks mobilenone">
        <ul className="d-flex justify-content-center m-0 align-items-center">
          <li className="nav-item"><a  href={`${feUrl}`} className="nav-link">{dataProp[0]?.attributes?.Icon1}</a></li>
          <li className="nav-item megamenu"><a className="dropdown-toggle nav-link">{dataProp[0]?.attributes?.Icon2}</a>
            <ul  className="dropdown-menu">
            {dataProp[0]?.attributes?.Icon2Options.map((item, index) => (
             <li><a href={`${feUrl}${item.link}`}>{item.text}</a></li>
            ))}
            </ul>
          </li>
          <li  className="nav-item"><a  href={`${feUrl}/events`} className="nav-link">{dataProp[0]?.attributes?.Icon3}</a></li>
          {isSignedUp?<>
          </>:
          <li className="nav-item megamenu"><a className="dropdown-toggle nav-link">{dataProp[0]?.attributes?.Icon4}</a>
          <ul  className="dropdown-menu">
          {dataProp[0]?.attributes?.Icon4Options.map((item, index) => (
           <li><a href={`${feUrl}${item.link}`}>{item.text}</a></li>
          ))}
          </ul>
        </li>
          }
          
        </ul>
      </div>
      <div className="d-flex justify-content-between m-0 align-items-center">

        <div className="d-none d-sm-block me-3 mobilenone">
          {isSignedUp ?
          <Button id="hawadagallo" onClick={handleLogOutClick} className="hoverBtn" sx={{backgroundColor:"white",color:"black","&:hover":{backgroundColor:"#212121",color:"white"}}}>Log out</Button> :
<a href={`${feUrl}/?type=investor`} className="commanbutton bg-white ms-3 d-block text-center">{dataProp[0]?.attributes?.ButtonText}</a> 
          }
        	</div>
          <div className="">
          <a id="slide" className="float-left" ><MenuIcon sx={{color:'white'}}/></a> 
        </div>
      </div>
    </div>
  </div>
</header>
</>
)
}

export default NavigationBar
